export const isEmpty = (value: string | undefined | null | Array<unknown>) =>
  !value ||
  (typeof value === 'string' && value.trim().length === 0) ||
  (Array.isArray(value) && value.length === 0);
